/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.S40_INDEX = {

  '@10': 
  [
     109,
  ],
  '@11': 
  [
     110,
     111,
     '111.1',
     112,
     114,
  ],
  '@16': 
  [
     '1682c',
  ],
  '@20': 
  [
     200,
     201,
     202,
     203,
     205,
     '205.1',
     '205.3',
     206,
     '206.1',
     208,
     '208.1',
     '208.2',
     '208.3',
     '208.4',
     2055,
     2060,
  ],
  '@21': 
  [
     210,
     '210.2',
     '210.3',
     '210.4',
     '210.5',
  ],
  '@22': 
  [
     '2220s!',
  ],
  '@23': 
  [
     '2320c!',
     '2322c!',
     '2323c!',
     '2330c!',
  ],
  '@26': 
  [
     '2600c!',
     '2680s!',
     2690,
     2692,
  ],
  '@27': 
  [
     '2700c!',
     '2710c',
     '2710c-2',
     '2720a!',
     '2730c!',
  ],
  '@30': 
  [
     300,
     301,
     '301.1',
     302,
     303,
     305,
     306,
     308,
     309,
     3020,
  ],
  '@31': 
  [
     310,
     311,
     '3109c',
     '3110c',
     '3120c',
     '3120classic',
  ],
  '@32': 
  [
     '3208c',
  ],
  '@35': 
  [
     '3500c',
     '3555b',
  ],
  '@36': 
  [
     '3600s',
     '3610a',
  ],
  '@37': 
  [
     '3710fold',
     '3720c',
  ],
  '@50': 
  [
     '5000!',
  ],
  '@51': 
  [
     515,
     '515.2',
     '5130!',
     '5130c!',
     5132,
  ],
  '@52': 
  [
     '5200!',
     '5220!',
  ],
  '@53': 
  [
     '5300!',
     '5310!',
     5330,
     '5330-1d',
  ],
  '@56': 
  [
     '5610d!',
  ],
  '@60': 
  [
     '6070!',
  ],
  '@62': 
  [
     '6208c',
     '6212c',
     '6260s!',
     '6230i!',
     6233,
     6234,
     '6263!',
     6280,
  ],
  '@63': 
  [
     6300,
     '6300i',
     6301,
     '6303c',
     '6303classic',
     '6303iclassic',
     '6303ci',
     6350,
  ],
  '@65': 
  [
     '6500s!',
  ],
  '@66': 
  [
     '6600f!',
     '6600s!',
     '6600i!',
  ],
  '@67': 
  [
     '6700c!',
     '6750c',
  ],
  '@70': 
  [
     '7070!',
  ],
  '@71': 
  [
     '7100s!',
  ],
  '@72': 
  [
     '7210s!',
     '7210Supernova!',
     '7230!',
  ],
  '@73': 
  [
     '7310c!',
  ],
  '@75': 
  [
     7500,
     '7510Supernova!',
  ],
  '@76': 
  [
     '7610Supernova!',
  ],
  '@88': 
  [
     '8800!',
  ],
  '@C1': 
  [
     'C1-01!',
     'C1-02!',
     'C1-03!',
  ],
  '@C2': 
  [
     'C2-00!',
     'C2-01!',
     'C2-02!',
     'C2-03!',
     'C2-05!',
     'C2-06!',
  ],
  '@C3': 
  [
     'C3-00!',
     'C3-01!',
  ],
  '@X2': 
  [
     'X2-00!',
     'X2-01!',
     'X2-02!',
     'X2-03!',
     'X2-05!',
  ],
  '@X3': 
  [
     'X3-00!',
     'X3-02!',
  ],
};

/* This file is automatically generated, do not edit manually! */
